export default __webpack_public_path__ + "static/home-video-3eddcf5340d58b281f4c7097b454ea0d.webm";